export const SET_TOGGLE = 'SET_TOGGLE';
export const SET_PROMPT_LOADING = 'SET_PROMPT_LOADING';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_SHOW_INTERPRETERS = 'SET_SHOW_INTERPRETERS';
export const SET_SHOW_HOUSE = 'SET_SHOW_HOUSE';
export const SET_SHOW_AVAILABLE = 'SET_SHOW_AVAILABLE';
export const SET_SHOW_CONTRACTS = 'SET_SHOW_CONTRACTS';
